/**
 * Header 컴포넌트
 */

import React, { useState } from 'react';
import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import { theme } from '../../../styles/theme';
import { mediaQueries } from '../../../constants/breakpoints';
import { Navigation } from '../Navigation';

const HeaderContainer = styled.header`
  position: sticky;
  top: 0;
  z-index: 1000;
  background-color: ${theme.colors.background};
  box-shadow: ${theme.shadows.sm};
`;

const HeaderInner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: ${theme.spacing.md} ${theme.spacing.lg};
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${mediaQueries.maxMobile} {
    padding: ${theme.spacing.md};
  }
`;

const Logo = styled(Link)`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.md};
  font-size: ${theme.fontSizes.xxl};
  font-weight: 700;
  font-family: ${theme.fonts.heading};
  color: ${theme.colors.primary};
  text-decoration: none;

  &:hover {
    color: ${theme.colors.secondary};
  }

  ${mediaQueries.maxMobile} {
    font-size: ${theme.fontSizes.xl};
    gap: ${theme.spacing.sm};
  }
`;

const LogoImage = styled.img`
  height: 50px;
  width: auto;
  object-fit: contain;

  ${mediaQueries.maxMobile} {
    height: 40px;
  }
`;

const MenuButton = styled.button`
  display: none;
  background: none;
  border: none;
  font-size: ${theme.fontSizes.xl};
  color: ${theme.colors.primary};
  cursor: pointer;
  padding: ${theme.spacing.sm};

  ${mediaQueries.maxTablet} {
    display: block;
  }
`;

export const Header: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <HeaderContainer>
      <HeaderInner>
        <Logo to="/">
          <LogoImage src="/title.png" alt="위례세움교회 로고" />
          위례세움교회
        </Logo>
        <MenuButton onClick={toggleMobileMenu}>
          {isMobileMenuOpen ? '✕' : '☰'}
        </MenuButton>
        <Navigation isMobileOpen={isMobileMenuOpen} onClose={() => setIsMobileMenuOpen(false)} />
      </HeaderInner>
    </HeaderContainer>
  );
};
